import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-brand-accent text-white font-bold py-4 px-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-center text-lg sm:text-xl ${fullWidth ? 'w-full' : 'w-full sm:w-auto'} ${className}`} {...props} data-id="element-33">
      {children}
    </motion.button>;
}